import { Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';
import { DemoService } from '../../../demo.service';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { HotToastService } from '@ngneat/hot-toast';
import { BsModalService, TabsetComponent } from 'ngx-bootstrap';
import { DataService } from '../../../admin/system-log-manager/data.service';
import { Location } from '@angular/common';
import { GlobalFunctionsService } from '../../../services/global-functions.service';


@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.css']
})
export class PaymentsComponent implements OnInit {


  modalRef: any;

  // TABS sets the selected
  @ViewChild('staticTabs') staticTabs: TabsetComponent;

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     private modalService: BsModalService, viewRef: ViewContainerRef,
     private _location: Location,  public gfunc: GlobalFunctionsService
  ) { }

  ngOnInit() {
  }


// MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
//  this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};

      /// TABS
      selectTab(tab_id: number) {
        this.staticTabs.tabs[tab_id].active = true;
      };


refreshGrid() { // refresh the databutton
  // this.getFiles();

};
// to router navigate back
   public goBack() {
    this._location.back();
    }


  }
  